import {useEffect} from 'react';
import environment from '../env-config';
import i18n, {resources, refreshTranslationConstants} from './index';
import {languageSettings} from './languageSettings';
import {createRemoteTranslations} from './remoteTranslations';

const getEndpoint = language => {
    const base = environment.REACT_BACKEND_URL || window.location.origin;
    const origin = new URL(base, window.location.origin).origin;
    return `${origin}/api/translations/v1/${language}`;
};
const remotes = {};
export default function useRemoteTranslations({enabled = true} = {}) {
    useEffect(() => {
        // Public prerendering is deterministic and always uses bundled English.
        if (!enabled) {void i18n.changeLanguage('en');return undefined;}
        if (navigator.userAgent.includes('ReactSnap') || typeof window.snapSaveState === 'function') return undefined;
        const refreshCurrent = () => {
            const language = Object.prototype.hasOwnProperty.call(resources, i18n.language) ? i18n.language : 'en';
            if (!remotes[language]) remotes[language] = createRemoteTranslations({
            i18n, language,
            baseline: resources.en,
            endpoint: getEndpoint(language),
            storage: {
                getItem: key => window.localStorage.getItem(key),
                setItem: (key, value) => window.localStorage.setItem(key, value),
            },
            fetcher: (...args) => window.fetch(...args),
            onApplied: refreshTranslationConstants,
        });
        return remotes[language].refresh();
        };
        void languageSettings.restore().then(refreshCurrent);
        const refresh = () => { if (document.visibilityState === 'visible') void refreshCurrent(); };
        i18n.on('languageChanged', refreshCurrent);
        document.addEventListener('visibilitychange', refresh);
        window.addEventListener('focus', refresh);
        return () => {
            i18n.off('languageChanged', refreshCurrent);
            document.removeEventListener('visibilitychange', refresh);
            window.removeEventListener('focus', refresh);
        };
    }, [enabled]);
}
